/**
 * Ask Ollie draft for a Progress job. Keep in sync with Express
 * `config/successHub.js` → `askOllie.questionsByFeatureId` (landing screens
 * do not re-fetch the Hub).
 */

export const SUCCESS_HUB_ASK_OLLIE_LABEL = 'Ask Ollie about this job'

/** @type {Readonly<Record<string, string>>} */
export const SUCCESS_HUB_ASK_OLLIE_QUESTIONS = Object.freeze({
  ordering: 'How do I place an order in OMS?',
  ollie_ordering:
    'How do I get Ollie to build today’s basket from my shopping list?',
  recipes: 'How do I cost a dish so I know the GP?',
  par_levels: 'How do I set a par on something I already buy?',
  stock_takes: 'How do I count stock and order the gap to par?',
  suppliers: 'How do I add a supplier I already buy from?',
  invoice_uploads: 'How do I upload an invoice?',
  restricted_suppliers: 'How do I restrict a supplier from ordering?',
  standing_orders: 'How do I set up a standing order?',
  goods_receipting: 'How do I receipt a delivery?',
})

/**
 * @param {string} [featureId]
 * @param {{ label?: string, question?: string }|null} [fromHub]
 * @returns {{ label: string, question: string } | null}
 */
export function resolveProgressAskOllie(featureId, fromHub = null) {
  const hubQuestion = String(fromHub?.question || '').trim()
  const hubLabel = String(fromHub?.label || '').trim()
  if (hubQuestion) {
    return {
      label: hubLabel || SUCCESS_HUB_ASK_OLLIE_LABEL,
      question: hubQuestion,
    }
  }
  const id = String(featureId || '').trim()
  if (!id) return null
  const question = String(SUCCESS_HUB_ASK_OLLIE_QUESTIONS[id] || '').trim()
  if (!question) return null
  return { label: SUCCESS_HUB_ASK_OLLIE_LABEL, question }
}
